export const QUERY_COURSE_CATEGORIES = `
query MyQuery {
   courseCategory(orderBy: "createdAt") {
     nodes {
       id
       name
       createdAt
       position
     }
   }
 }
`

export const QUERY_COURSE_SUB_CATEGORIES = `
query MyQuery($categoryID: String ) {
  courseSubCategory(orderBy: "createdAt", categoryID: $categoryID) {
     nodes {
      categoryID
      createdAt
      id
      name
      updatedAt
      position
     }
   }
 }
`

export const QUERY_COURSES = `
query MyQuery($subCategoryId: String, $name: String, $isFeatured: Boolean) {
  course(orderBy: "createdAt", subCategoryId: $subCategoryId, name: $name, isFeatured: $isFeatured) {
    nodes {
      updatedAt
      subCategoryId
      startDate
      projectWebsite
      projectName
      bannerURL
      categoryId
      createdAt
      description
      endDate
      id
      isFeatured
      featuredPosition
      logoURL
      maxAttendees
      name
      noMaxAttendees
      noOfAttempted
      timeRequired
      noExpiry
      numberOfTicketAward
      position
    }
  }
}
`

export const QUERY_LESSONS = `
query MyQuery ($courseID: String){
  lesson(courseID: $courseID, orderBy: "createdAt") {
    nodes {
      courseID
      createdAt
      id
      mediaURL
      text
      title
      position
    }
  }
}
`

export const QUERY_QUESTIONS = `
query MyQuery ($courseID: String){
  question(courseID: $courseID, orderBy: "createdAt") {
    nodes {
      courseID
      createdAt
      id
      text
      updatedAt
      answers {
        createdAt
        id
        questionID
        text
      }
    }
  }
}
`

export const QUERY_TELEGRAM_MESSAGES = `
query MyQuery ($limit: Int, $offset: Int, $orderBy: String){
  telegramMessage(limit:$limit, offset:$offset, orderBy:$orderBy) {
    nodes {
      attachment
      createdAt
      recipient
      id
      recipientIds
      text
      actions
    }
  }
}
`